<div class="sportsbook-home__content">
  <h1 class="sr-only">{{ 'home.pageTitle' | translate }}</h1>

  <app-banner></app-banner>

  <section
    #sportFilters
    class="sportsbook-home__filters"
    tabindex="-1"
    [attr.aria-label]="'filters.navLabel' | translate"
  >
    <app-mobile-sports-bar
      [sports]="sportsbook.sports()"
      [loading]="isMatchDataLoading()"
      (sportToggle)="sportsbook.toggleSport($event)"
    ></app-mobile-sports-bar>

    <app-match-filter
      [filters]="sportsbook.filterOptions"
      [activeFilter]="sportsbook.activeFilter()"
      [searchVisible]="!isMobile()"
      [searchExpanded]="sportsbook.searchExpanded()"
      [searchQuery]="sportsbook.searchQuery()"
      (filterChange)="sportsbook.setActiveFilter($event)"
      (searchToggle)="sportsbook.toggleSearch()"
      (searchChange)="sportsbook.setSearchQuery($event)"
    ></app-match-filter>
  </section>

  @if (isMatchDataLoading()) {
    <section class="sportsbook-home__groups" aria-busy="true" aria-live="polite">
      <span class="sportsbook-home__sr-only">{{ 'home.loading' | translate }}</span>

      @for (rowCount of loadingGroupRowCounts; track $index) {
        <app-tournament-group-skeleton [rowCount]="rowCount" [mobile]="isMobile()"></app-tournament-group-skeleton>
      }
    </section>
  } @else {
    <section class="sportsbook-home__groups">
      <p class="sr-only" role="status" aria-atomic="true">
        {{ 'home.resultSummary' | translate: { count: visibleTournamentGroups().length } }}
      </p>

      @if (visibleTournamentGroups().length) {
        @for (group of visibleTournamentGroups(); track group.id) {
          <app-tournament-group
            [group]="group"
            [mobile]="isMobile()"
            [selectedQuickGroupId]="sportsbook.getSelectedQuickGroupId(group.sportId)"
            (selectedQuickGroupChange)="sportsbook.setSelectedQuickGroupId(group.sportId, $event)"
            (toggleExpanded)="sportsbook.toggleTournament($event)"
            (selectionToggle)="sportsbook.toggleSelection($event)"
            (openMatchDetail)="openMatchDetail($event)"
          ></app-tournament-group>
        }

        @if (hasMoreTournamentGroups()) {
          <button
            #autoLoadTrigger
            type="button"
            class="sportsbook-home__auto-load-trigger sr-only-focusable"
            (click)="showMoreTournamentGroups()"
          >
            {{ 'home.showMore' | translate }}
          </button>
        }
      } @else if (!matchDataLoadFailed()) {
        <div class="sportsbook-home__empty sb-card-shell">
          <h2>{{ 'home.emptyTitle' | translate }}</h2>
          <p>{{ 'home.emptyDescription' | translate }}</p>
        </div>
      }
    </section>
  }
</div>
